import store from 'Store';

/**
 * Get param storeModules from route meta, load module and register it in store, if module not exist
 * @param to {VueRouter.Route}
 * @param to.matched[0].meta.storeModules {Array<Record{ name: string, module: () => Promise<StoreModule> }>}
 * @returns {Promise<void>}
 */
export async function resolveStoreModules(to) {
  const storeModulesMeta = to.matched[0]?.meta?.storeModules;
  if (!storeModulesMeta) return;
  const storeModulesArray = Array.isArray(storeModulesMeta) ? storeModulesMeta : [storeModulesMeta];
  const promises = [];
  storeModulesArray.forEach(storeModuleImport => promises.push(storeModuleImport.module()));
  const modules = await Promise.all(promises);
  modules.forEach((module, index) => {
    const name = storeModulesArray[index]?.name;
    if (name && !store.hasModule(name)) {
      store.registerModule(name, module.default);
    }
  });
}
